import { Tag } from 'lucide-react'
import { cn } from '@/utils/cn'
import type { BlocoLabel } from '@/types/bloco'
import { hexToRgba, normalizeLabelColor } from './blocoLabelUtils'

interface BlocoLabelChipProps {
  label: BlocoLabel
  active?: boolean
  showIcon?: boolean
  className?: string
}

export function BlocoLabelChip({
  label,
  active = true,
  showIcon = false,
  className,
}: BlocoLabelChipProps) {
  const color = normalizeLabelColor(label.color)

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium',
        className,
      )}
      style={
        active
          ? { backgroundColor: color, color: '#fff' }
          : {
              backgroundColor: hexToRgba(color, 0.14),
              border: `1px solid ${hexToRgba(color, 0.45)}`,
              color,
            }
      }
    >
      {!active && (
        <span
          className='h-2 w-2 shrink-0 rounded-full'
          style={{ backgroundColor: color }}
          aria-hidden
        />
      )}
      {showIcon && <Tag size={10} />}
      {label.name}
    </span>
  )
}
